import React, { useEffect, useState } from 'react';
import { Timer } from 'lucide-react';

const pad = (n) => String(n).padStart(2, '0');

/** "Offer ends in 2 days" → live "5h 12m 09s" in the final 24 hours. */
const OfferCountdown = ({ expiresAt, language = 'en', testid }) => {
  const es = language === 'es';
  const [now, setNow] = useState(Date.now());
  const end = new Date(expiresAt).getTime();
  const left = end - now;
  const lastDay = left > 0 && left < 86400000;

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), lastDay ? 1000 : 60000);
    return () => clearInterval(id);
  }, [lastDay]);

  if (!expiresAt || left <= 0) return null;
  let text;
  if (lastDay) {
    const s = Math.floor(left / 1000);
    const clock = `${Math.floor(s / 3600)}h ${pad(Math.floor((s % 3600) / 60))}m ${pad(s % 60)}s`;
    text = es ? `La oferta termina en ${clock}` : `Offer ends in ${clock}`;
  } else {
    const days = Math.ceil(left / 86400000);
    text = es ? `La oferta termina en ${days} ${days === 1 ? 'día' : 'días'}` : `Offer ends in ${days} ${days === 1 ? 'day' : 'days'}`;
  }
  return (
    <p className={`mt-2 flex items-center justify-center gap-1.5 text-xs font-semibold ${lastDay ? 'text-red-600' : 'text-amber-700'}`} data-testid={testid}>
      <Timer className="h-3.5 w-3.5" />
      <span className="tabular-nums">{text}</span>
    </p>
  );
};

export default OfferCountdown;
